// extracted by mini-css-extract-plugin
export default {"error":"loading-wrapper_error__t+t9D","error-container":"loading-wrapper_error-container__LZE6c","loading-message":"loading-wrapper_loading-message__YJ67P"};